import { render } from "./OrderCardButtonModal.vue?vue&type=template&id=1ba8a74a"
import script from "./OrderCardButtonModal.vue?vue&type=script&lang=js"
export * from "./OrderCardButtonModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__